import { useState } from 'react';

const FAVORITES_KEY = 'flow-favorites';

export function useFavorites() {
  const [favorites, setFavorites] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem(FAVORITES_KEY);
      if (stored) return JSON.parse(stored) as string[];
    } catch {
      /* ignore corrupt data */
    }
    return [];
  });

  function toggleFavorite(id: string) {
    setFavorites(prev => {
      const next = prev.includes(id) ? prev.filter(f => f !== id) : [...prev, id];
      localStorage.setItem(FAVORITES_KEY, JSON.stringify(next));
      return next;
    });
  }

  function isFavorite(id: string): boolean {
    return favorites.includes(id);
  }

  return { favorites, toggleFavorite, isFavorite };
}
